"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const reducer_1 = __importDefault(require("./reducer"));
const initialState = {
    areChoicesOpen: false,
    isEditable: false,
    isFocused: false,
};
function usePrettyTextReducer() {
    const [state, dispatch] = react_1.useReducer(reducer_1.default, initialState);
    const actions = {
        blur() {
            dispatch('blur');
        },
        clickOutsideChoices() {
            dispatch('clickOutsideChoices');
        },
        clickTag() {
            dispatch('clickTag');
        },
        focusChoices() {
            dispatch('focusChoices');
        },
        focus() {
            dispatch('focus');
        },
        mouseEnter() {
            dispatch('mouseEnter');
        },
        closeChoices() {
            dispatch('closeChoices');
        },
        touchStart() {
            dispatch('touchStart');
        },
        mouseDown() {
            dispatch('mouseDown');
        },
    };
    return { state, actions };
}
exports.default = usePrettyTextReducer;
